import { ValueOptions } from "@mui/x-data-grid";
import { UniOption } from "./UniOption";

export class SpwkUtilV3 {
  /** UniAnswer 目前有多少個欄位 m01、m02、...m20 */
  static readonly ANS_M_CNT = 20;

  /* 特殊 RHF_NAME 先統一集中在此 */
  static readonly RHF_NAME_出生日期 = "基本資料.基本資料●出生日期●input_1";
  static readonly RHF_NAME_曾經從事_起始日期 =
    "作業經歷.曾經從事●起始日期●input_1";
  static readonly RHF_NAME_曾經從事_截止日期 =
    "作業經歷.曾經從事●截止日期●input_1";
  static readonly RHF_NAME_目前從事_起始日期 =
    "作業經歷.目前從事●起始日期●input_1";
  static readonly RHF_NAME_目前從事_截止日期 =
    "作業經歷.目前從事●截止日期●input_1";
  static readonly RHF_NAME_基本資料_受雇日期 =
    "基本資料.基本資料●受雇日期●input_1";

  static readonly YUP_ERROR_TYPE_FROM = "FORM";

  // static readonly HIS_RULE_BASIC = "A";

  static readonly Q_KIND_標題 = "標題";
  static readonly Q_KIND_單選 = "單選";
  static readonly Q_KIND_多選 = "多選";
  static readonly Q_KIND_非選 = "非選";
  static readonly Q_KIND_自訂 = "自訂"; // 人體圖...
  static readonly UcHumanBodyImage = "UcHumanBodyImage"; // 人體圖...
  static readonly BSRS5_ScoreIllustrate = "BSRS5_ScoreIllustrate"; // 人體圖...

  static readonly Q_CODE_吸菸 = "吸菸";
  static readonly Q_CODE_檳榔 = "檳榔";
  static readonly Q_CODE_喝酒 = "喝酒";

  static readonly FUNC_CODE_A01 = "A01"; // 一般
  static readonly FUNC_CODE_A98 = "A98"; // 夜間
  static readonly FUNC_CODE_B02 = "B02"; // 聽力

  static readonly FORM_GUID_F01v0 = "_F01v0";
  static readonly FORM_GUID_F02v0 = "_F02v0";
  static readonly FORM_GUID_F03v0 = "_F03v0";
  static readonly FORM_GUID_F04v0 = "_F04v0";
  static readonly FORM_GUID_F05v0 = "_F05v0";
  static readonly FORM_GUID_F06v0 = "_F06v0";

  static readonly FUNC_GUID_F01 = "_F01";
  static readonly FUNC_GUID_F02 = "_F02";
  static readonly FUNC_GUID_F03 = "_F03";
  static readonly FUNC_GUID_F04 = "_F04";
  static readonly FUNC_GUID_F05 = "_F05";
  static readonly FUNC_GUID_F06 = "_F06";

  static readonly IsEnabled = true;

  static readonly LANG_HIS: string = "HIS";
  static readonly LANG_CODE: string = "CODE";
  static readonly LANG_RHF_NAME: string = "RHF_NAME";
  static readonly LANG_GOV: string = "GOV";

  static get_Question_RhfName_V3(
    chapter: string,
    question_code: string
  ): string {
    return chapter + "." + question_code;
  }

  /** 多選(CheckBox)用的 RhfName */
  static get_Option_RhfName_V3(option: UniOption) {
    let chapter = option.question_chapter ?? "?????";
    let question_code = option.question_code ?? "?????";

    if (
      chapter === SpwkUtilV3.CHAPTER_既往病史 ||
      chapter === SpwkUtilV3.CHAPTER_自覺症狀
    ) {
      return chapter + "." + option.getV3Code();
    } else {
      return (
        SpwkUtilV3.get_Question_RhfName_V3(chapter, question_code) +
        "." +
        option.option_code
      );
    }
  }

  static get_Input_RhfName_V3(option: UniOption, input_code: string) {
    let chapter = option.question_chapter ?? "?????";
    let question_code = option.question_code ?? "?????";

    if (
      chapter === SpwkUtilV3.CHAPTER_既往病史 ||
      chapter === SpwkUtilV3.CHAPTER_自覺症狀
    ) {
      return chapter + "." + option.getV3Code() + "●input_" + input_code;
    } else {
      return (
        SpwkUtilV3.get_Question_RhfName_V3(chapter, question_code) +
        "●" +
        option.option_code +
        "●input_" +
        input_code
      );
    }
  }

  static readonly A01_func_guid = "_A01";
  static readonly A98_func_guid = "_A98";
  static readonly B02_func_guid = "_B02";

  static readonly CHAPTER_基本資料 = "基本資料";
  static readonly CHAPTER_檢查時期 = "檢查時期";
  static readonly CHAPTER_作業經歷 = "作業經歷";

  static readonly CHAPTER_既往病史 = "既往病史";
  static readonly CHAPTER_既往病史_噪音作業 = "既往病史(噪音作業)";

  static readonly CHAPTER_生活習慣 = "生活習慣";

  static readonly CHAPTER_自覺症狀 = "自覺症狀";
  static readonly CHAPTER_自覺症狀_噪音作業 = "自覺症狀(噪音作業)";

  static readonly CHAPTER_疲勞狀況 = "疲勞狀況";

  static readonly CHAPTER_環境監測 = "環境監測";

  static Get檢查時期HisCode(value: string) {
    if (value === "新進") {
      return "1";
    } else if (value === "定期") {
      return "2";
    } else if (value === "變更") {
      return "3";
    } else if (value === "追蹤") {
      return "4";
    } else if (value === "") {
      return "";
    } else {
      throw new Error(
        "643135 Get檢查時期HisCode():: 未知的 value=" + value + "!!!"
      );
    }
  }

  static readonly TOKEN_呼吸困難 = "呼吸困難";
}

export enum HisRule {
  None = "",
  PASS = "PASS", // 跳過此題，此題可能是 基本檔(只看Input)，或其他情況，確定不需對此問題處理
  BasicString = "{S}",
  BasicDate = "{D}",
  BasicNumber = "{N}",
  BasicRadio = "{R}",
  BasicCustom = "{X}",

  CH2_B02 = "CH2_B02", // 噪音.作業經歷

  CH2_B02_52 = "CH2_B02_52", // 噪音.作業經歷 52這題 (格式例外，先偷懶不想通用格式)

  CH4 = "CH4", // 解碼規則: 既往病史
  CH6 = "CH6", // 解碼規則: 自覺症狀

  CH5 = "CH5", // 解碼規則: 生活習慣

  Tired = "Tired", // 疲勞問卷
  CH7 = "CH7", // 解碼規則: 環境監測
}
export const HisRuleOptions: ValueOptions[] = [
  { value: HisRule.None, label: "(尚未定義)" },
  { value: HisRule.PASS, label: "(PASS)" },

  { value: HisRule.BasicString, label: "基本檔.字串" },
  { value: HisRule.BasicDate, label: "基本檔.日期" },
  { value: HisRule.BasicNumber, label: "基本檔.數字" },
  { value: HisRule.BasicRadio, label: "基本檔.單選" },
  { value: HisRule.BasicCustom, label: "基本檔.自訂" },

  { value: HisRule.CH2_B02, label: "CH2_B02 噪音.作業經歷" },
  { value: HisRule.CH2_B02_52, label: "CH2_B02_52" },
  { value: HisRule.CH4, label: "CH4 既往病史" },
  { value: HisRule.CH6, label: "CH6 自覺症狀" },
  { value: HisRule.CH5, label: "CH5 生活習慣" },
  { value: HisRule.Tired, label: "Tired 疲勞問卷" },
  { value: HisRule.CH7, label: "CH7 環境監測" },
];

export enum EnableMode {
  皆可更改 = "",
  皆不可更改 = "0",
  院方可改 = "2",
  受檢者有數值時不可改 = "3",
}

export const EnableModeOptions = [
  { value: EnableMode.皆可更改, label: "皆可更改" },
  { value: EnableMode.院方可改, label: "院方可改" },
  { value: EnableMode.受檢者有數值時不可改, label: "受檢者有數值時不可改" },
  { value: EnableMode.皆不可更改, label: "皆不可更改" },
];

export enum VisibleMode {
  皆可見 = "",
  皆不可見 = "0",
  院方可見 = "2",
}

export const VisibleModeOptions = [
  { value: VisibleMode.皆可見, label: "皆可見" },
  { value: VisibleMode.皆不可見, label: "皆不可見" },
  { value: VisibleMode.院方可見, label: "院方可見" },
];

export enum RequiredMode {
  必填 = "", // 空白 = input 預設必填;
  選填 = "0",
}

export const RequiredModeOptions = [
  { value: RequiredMode.必填, label: "必填(預設)" },
  { value: RequiredMode.選填, label: "選填" },
];
